export const ENDPOINT_DROPPOINTS =
	'ws-delivery-methods/v2/delivery-methods/countries'
export const ENDPOINT_STORES_FINDER_LITE = 'ws-store-finder/v2/stores/lite'
export const ENDPOINT_STORES_FINDER = 'ws-store-finder/v2/store'
export const ENDPOINT_STORES_FINDER_RFID = '/ws/0/store-finder/v1/stores/stock'
export const ENDPOINT_STORES_GARMENTS = 'ws-store-finder/v2/stores/garments'
export const ENDPOINT_GEOCODING_SERVICE = '/woosmap/address/geocode/json'

export const ERROR_MESSAGE_KEYS = {
	NO_STORES_NEARBY: 'storeLocator.searchBox.noResults.text',
	NO_STORES_FOR_PRODUCT: 'storeFinder.searchBox.noStock.errormessage',
	NO_STORES_FOR_LOCATION: 'storeFinder.searchBox.errormessage',
	NO_STOCK_ON_STORES: 'storeLocator.storeAvailability.noStock.text',
	NO_DROPPOINTS_FOR_LOCATION: 'storeLocator.searchBox.dropPoint.errormessage',
}

export const PLACEHOLDER_KEYS = {
	DEFAULT: 'storeLocator.searchBox.placeholder',
	DROPPOINT: 'storeLocator.searchBox.dropPoint.placeholder',
}

export const STORAGE_KEY = 'latestSearchedLocation'
